const leaguePlugin = (state = {}, {type, payload}) => {
  switch (type) {
    case 'LEAGUE_PLUGIN.INIT':
      return { ...state, ...payload }
    default:
      return state
  }
}

export default leaguePlugin
